
// This file was AutoGenerated at Sat May 31 2025 22:17:37 GMT+0000 (Coordinated Universal Time) by 'generate-api.js'

import { createApiProxy } from '@/infrastructure/api-proxy-core';
import { credentialsManager } from '@/infrastructure/session-management/credential-manager';
import { AuthenticationApi, NotesApi, UsersApi } from '../api/api'

export class ApiFacade {
	public static get AuthenticationApi(): AuthenticationApi {
		return createApiProxy(new AuthenticationApi({ apiKey: credentialsManager.getToken() }));
	}

	public static get NotesApi(): NotesApi {
		return createApiProxy(new NotesApi({ apiKey: credentialsManager.getToken() }));
	}

	public static get UsersApi(): UsersApi {
		return createApiProxy(new UsersApi({ apiKey: credentialsManager.getToken() }));
	}

}
